import { render, staticRenderFns } from "./ProductsGS1.vue?vue&type=template&id=4917ae48&"
import script from "./ProductsGS1.vue?vue&type=script&lang=js&"
export * from "./ProductsGS1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports